import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=68ebc591&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=js"
export * from "./Scoreboard.vue?vue&type=script&lang=js"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&id=68ebc591&prod&lang=scss&scoped=true"
import style1 from "./Scoreboard.vue?vue&type=style&index=1&id=68ebc591&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ebc591",
  null
  
)

export default component.exports